export default "/images/vendor/flag-icon-css/flags/4x3/nc.svg?52e1a836ab19668f7052d3086eb2f3c9";